import React, { useEffect, useRef, forwardRef } from 'react';

interface MouseFollowEffectProps {
  children: React.ReactNode;
  className?: string;
}

const MouseFollowEffect = forwardRef<HTMLDivElement, MouseFollowEffectProps>(
  ({ children, className = '' }, ref) => {
    const elementRef = useRef<HTMLDivElement>(null);

    // Check if we're on a special page that needs a more subtle effect
    const isSpecialPage = window.location.pathname.includes('carbon-negative-era') || 
                          window.location.pathname.includes('pride-staff') || 
                          window.location.pathname.includes('lovenood');

    useEffect(() => {
      const element = ref ? (ref as React.RefObject<HTMLDivElement>).current : elementRef.current;
      if (!element) return;

      const handleMouseMove = (e: MouseEvent) => {
        const rect = element.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / element.clientWidth) * 100;
        const y = ((e.clientY - rect.top) / element.clientHeight) * 100;
        
        element.style.setProperty('--mouse-x', `${x}%`);
        element.style.setProperty('--mouse-y', `${y}%`);
      };

      element.addEventListener('mousemove', handleMouseMove);
      return () => element.removeEventListener('mousemove', handleMouseMove);
    }, [ref]);

    return (
      <div ref={ref || elementRef} className={`service-card ${isSpecialPage ? 'special-page-card' : ''} ${className}`}>
        {children}
      </div>
    );
  }
);

export default MouseFollowEffect;